/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} UsernameInputs */

const en_username = /** @type {(inputs: UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`username`)
};

const es_username = /** @type {(inputs: UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nombre_de_usuario`)
};

const fr_username = /** @type {(inputs: UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nom_d_utilisateur`)
};

const de_username = /** @type {(inputs: UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`benutzername`)
};

const ja_username = /** @type {(inputs: UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザーネーム`)
};

const zh_username = /** @type {(inputs: UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用户名`)
};

const ar_username = /** @type {(inputs: UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسم_المستخدم`)
};

const id_username = /** @type {(inputs: UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`namapengguna`)
};

const it_username = /** @type {(inputs: UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nome_utente`)
};

const ru_username = /** @type {(inputs: UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`имя_пользователя`)
};

const pt_username = /** @type {(inputs: UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nome_de_usuario`)
};

const ko_username = /** @type {(inputs: UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사용자 이름`)
};

/**
* | output |
* | --- |
* | "username" |
*
* @param {UsernameInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const username = /** @type {((inputs?: UsernameInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<UsernameInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_username(inputs)
	if (locale === "es") return es_username(inputs)
	if (locale === "fr") return fr_username(inputs)
	if (locale === "de") return de_username(inputs)
	if (locale === "ja") return ja_username(inputs)
	if (locale === "zh") return zh_username(inputs)
	if (locale === "ar") return ar_username(inputs)
	if (locale === "id") return id_username(inputs)
	if (locale === "it") return it_username(inputs)
	if (locale === "ru") return ru_username(inputs)
	if (locale === "pt") return pt_username(inputs)
	return ko_username(inputs)
});